import React, { useEffect, useState } from 'react'
import NumberFormat from './NumberFormat'
import { Link } from "react-router-dom"
import ReduceBigNumbers from './ReduceBigNumbers'

function TablesList( data ) {
  const socket = data.socket
  const [ path, setPath ] = useState( false )
  const setdataForRoomEntry = ( _id, user )=>{
    data.setdataForRoomEntry({
      criteries : {
        _id : _id,
      },
      becomeAVisitor : true,
      user : user
    })
  }


  useEffect(()=>{
    if( data.user ) setPath( '/room' )
    if( !data.user ) setPath( null )
  }, [ data.user ])
  

  const authoriseOrContinue = ( func, funcProp, funcProp2 )=>{
    console.log(arguments)
    console.log(func)
    console.log(funcProp)
      console.log(funcProp2)
    if( !data.user ){
      socket.emit( 'generateUser', {} )
      data.setActionsAfterAuth({
        linkPath : '/room',
        func : func,
        funcProp : funcProp,
        funcProp2 : funcProp2
      })
    }else{
      func( funcProp, funcProp2 )
    }
    // if( !data.user ){
    //   data.setActionsAfterAuth({
    //     linkPath : '/room',
    //     func : func,
    //     funcProp : funcProp,
    //     funcProp2 : funcProp
    //   })
    //   data.toggleAuth( true )
    // }else{
    //   func( funcProp, funcProp2 )
    // }
  }

  let list

  if( data.width > 1000 ){
    let limBadge = 0
    
    list = data.tableList?.map( table => (
      <Link key={ table.gameConfig._id } to={ path } onClick={ ()=>{ authoriseOrContinue( setdataForRoomEntry, table.gameConfig._id, data.user )}}>
        <div className='tableRaw'>
          <div className='tableRawDetails'>
              <div className='tableRawGameType'><p>{ table.gameConfig.name }</p></div>
              <div className='tableRawGameLimitsWrapper'>
                <div className={'tableRawGameLimits timeBadge' + table.gameConfig.time }>
                  <p className={ "timeBadgeValue" }>{ table.gameConfig.time }</p>
                  <p className="timeBadgeSec">sec</p>
                </div>
                <div className={'tableRawGameLimits' + ' limitBadge' +  limit( table.gameConfig.limit ).replace(/\s+/g, ' ').trim() }><p>{ limit( table.gameConfig.limit ) }</p></div>
              </div>
              <div className='tableRawGameBlinds'><p>{ ReduceBigNumbers( table.gameConfig.smallBlind ) + '/' + ReduceBigNumbers( table.gameConfig.bigBlind ) }</p></div>
              <div className='tableRawGameBuyIn'><p>{ ReduceBigNumbers( table.gameConfig.maxBuyIn ) }</p></div>
              <div className='tableRawPlayersStack'>{ participants( table.participants ) }</div>
          </div>
          {/* <div className='tableDevider'></div> */}
        </div>
      </Link>
    ))
  }else{
    list = data.tableList?.map( table => (
      <Link key={ table.gameConfig._id } to={ path } onClick={ ()=>{ authoriseOrContinue( setdataForRoomEntry, table.gameConfig._id, data.user )}}>
        <div className='tableRaw'>
          <div className='tableRawDetails'>
            <div className='tableRawGameTypeHolder'>
              <div className='tableRawGameType'>{ table.gameConfig.name }</div>
              <div className='tableRawGameLimitsWrapper'>
                <div className={'tableRawGameLimits timeBadge' + table.gameConfig.time }>
                  <p className={ "timeBadgeValue" }>{ table.gameConfig.time }</p>
                  <p className="timeBadgeSec">sec</p>
                </div>
                <div className={'tableRawGameLimits' + ' limitBadge' +  limit( table.gameConfig.limit ).replace(/\s+/g, ' ').trim() }><p>{ limit( table.gameConfig.limit ) }</p></div>
              </div>
            </div>
            <div className='tableRawPlayersStack'>{ participants( table.participants ) }</div>
            <div className='tableRawGameBlindsWrapper'>
              <div className='tableRawGameBlinds'><p>{ ReduceBigNumbers( table.gameConfig.smallBlind ) + '/' + ReduceBigNumbers( table.gameConfig.bigBlind ) }</p></div>
              <div className='tableRawGameBuyIn'><p>{ ReduceBigNumbers( table.gameConfig.maxBuyIn ) }</p></div>
            </div>
          </div>
          {/* <div className='tableDevider'></div> */}
        </div>
      </Link>
    ))
  }

  


  function limit ( lim ){
    switch( lim ){
        case 'lim' : return( 'Limit' )
        case 'potlim' : return( 'Pot-Limit' )
        case 'unlim' : return( 'Unlimit' )
        default : return( lim )
    }
  }


  function participants ( participants ){
    try{
        let i = 0
        let players = participants.map(( p )=>{
            if( p.participant ){
                let r = <div className='tablePlayerImageHolder' style={{ marginLeft: 0 + 'px' }} key={i} ><img className='tablePlayerImage' alt="Player's avatar" title="Avatar that uses if player temporarily has no video stream" src={ 'images/petAvatars/' + p.participant.avatar + '.jpeg' }></img></div>
                i += 30
                return( r )
            }
        })
        return players
    }catch( e ){
        console.log( e )
    }
  }


  if( data.width > 1000 ){
    return (
      <div className='tableChart'>
        <div className='tableHeader'>
            <div className='tableHeaderItems'>
                <div className='tableHeaderGameTypeItem'><p>Table</p></div>
                <div className='tableHeaderItemIncative '><p>Action time, Limit</p></div>
                <div className='tableHeaderItemIncative tableHeaderItemIncativeBlinds'><p>Blinds</p></div>
                <div className='tableHeaderItemIncative tableHeaderItemIncativeBuyIn'><p>Buy In</p></div>
                <div className='tableHeaderItemIncative'><p>Players</p></div>
            </div>
            <div className='tableHeaderDevider'></div>
        </div>
        <div className='tableBody'>{ list }</div>
      </div>
    )     
  }else{
    return (
      <div className='tableChart'>
        <div className='tableHeader'>
            <div className='tableHeaderItems'>
                <div className='tableHeaderGameTypeItem'><p>Table, Action time, Limit</p></div>
                <div className='tableHeaderItemIncative tableHeaderItemIncativeLimits'><p>Players</p></div>
                <div className='tableHeaderItemIncative tableHeaderItemIncativeBlinds'>
                  <p>Blinds,</p>
                  <p>Buy In</p>
                </div>
                {/* <div className='tableHeaderItemIncative tableHeaderItemIncativeBuyIn'><p>Buy In Limits</p></div> */}
            </div>
            <div className='tableHeaderDevider'></div>
        </div>
        <div className='tableBody'>{ list }</div>
      </div>
    ) 
  }
}

export default TablesList